import React, { Component } from 'react';

export default class SorList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let sorSpreadsheets = this.props.data.map((sor, index) => {
            return (
                <tr key={index}>
                    <td>{sor.id}</td>
                    <td>{sor.customer_contact.customer.name}</td>
                    <td>{sor.customer_contact.first_name + ' ' + sor.customer_contact.last_name}</td>
                    <td>{sor.customer_contact.department.name}</td>
                    <td>{moment(sor.created_at).format('DD/MM/YYYY')}</td>
                    <td>
                        <a
                            href={this.props.downloadUrl
                                .replace('customer:id', sor.customer_contact.customer.id)
                                .replace('sor:id', sor.id)}
                            className="d-block"
                        >
                            {sor.name}
                        </a>
                    </td>
                </tr>
            );
        });
        return (
            <table className="table transform-text">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Customer name</th>
                        <th>Contact name</th>
                        <th>Department</th>
                        <th>Created</th>
                        <th>Download</th>
                    </tr>
                </thead>
                <tbody>{sorSpreadsheets}</tbody>
            </table>
        );
    }
}
